import { KYMW2200Model } from '../kymw2200.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * メール送信前チェック
  *
 * @export
 * @class CheckSendOCRDataService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class CheckSendOCRDataService extends PlessJsonResponderSub<any> {

  vo = {
    OrderCode: ''
  };

  // 処理に使用するModel
  private model: KYMW2200Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof CheckSendOCRDataService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.OrderCode,
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof CheckSendOCRDataService
   */
  execute(model: KYMW2200Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('checkSendOCRData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof CheckSendOCRDataService
   */
  success(data: any) {
    this.successFunc(data);
  }
}
